import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import {
  getUsersPaginated,
  deleteUser,
  changeStatusUser,
} from "../../../../api/user";
import { Button, Tooltip, Switch, FormControlLabel } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import { Autorenew as FilterOffIcon } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import { shallowEqual, useSelector } from "react-redux";
import FiltersCard from "../../../components/filters/Filter";
import { getUserTypes } from "../../../../api/userType";
import { getProvincias } from "../../../../api/provincia";
import {
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
  Select as MuiSelect,
} from "@material-ui/core";
import Select from "react-select";
import {
  canEditUsersModule,
  isReadOnlyConsultor,
} from "../../../../_helpers/backofficePermissions";

function getData(users, types) {
  let data = [];
  if (!users || !Array.isArray(users)) return data;
  for (let i = 0; i < users.length; ++i) {
    if (users[i] && users[i].role === "user") {
      const elem = {};
      elem.name = users[i].fullName;
      elem.apellido1 = users[i].apellido1;
      elem.apellido2 = users[i].apellido2;
      elem.nickname = users[i].nickname;
      elem.dni = users[i].dni;
      elem.afiliado = users[i].afiliado;
      elem.ultimoPago = users[i].ultimoPago;
      elem.email = users[i].email;
      elem.type = types?.find((x) => x._id == users[i].type)?.titulo; // Mostrar nombre
      elem.typeId = users[i].type ? String(users[i].type) : null; // Guardar ID para filtros
      elem.nAso = users[i].nAso;
      elem.asociado = users[i].asociado;
      elem.jm = users[i].jm;
      elem.mailing = users[i].mailing;
      elem.createdAt = users[i].createdAt;
      elem.fechaAlta = users[i].fechaAlta; // Para filtro de fecha
      elem.provincia = users[i].provincia; // Para filtro de provincia
      elem.id = users[i]._id;
      elem.active = users[i].active;
      data = data.concat(elem);
    }
  }
  return data;
}

const initialFilters = {
  active: false,
  tipoUsuario: [],
  fechaAltaDesde: "",
  fechaAltaHasta: "",
  provincia: null,
  numeroSocio: "",
};

const PAGE_SIZE_OPTIONS = [25, 50, 100];

// Mapeo dataField (tabla) -> campo en backend para ordenación
const SORT_FIELD_TO_BACKEND = {
  name: "fullName",
  apellido1: "apellido1",
  apellido2: "apellido2",
  dni: "dni",
  email: "email",
  type: "type",
  createdAt: "createdAt",
};

export default function UsersPage() {
  const [data, setData] = useState([]);
  const [userId, setUserId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [userTypes, setUserTypes] = useState([]);
  const [users, setUsers] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  const [provincias, setProvincias] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(() => {
    const saved = localStorage.getItem("usersPage_currentPage");
    return saved ? parseInt(saved, 10) : 1;
  });
  const [totalPages, setTotalPages] = useState(1);
  const [totalUsers, setTotalUsers] = useState(0);
  const normalizeTipoUsuario = (raw) =>
    Array.isArray(raw?.tipoUsuario)
      ? raw.tipoUsuario
      : raw?.tipoUsuario
        ? [raw.tipoUsuario]
        : [];
  // Cargar filtros desde localStorage al iniciar
  const [filterOptions, setFilterOptions] = useState(() => {
    const savedFilters = localStorage.getItem("usersPageFilters");
    const raw = savedFilters ? JSON.parse(savedFilters) : initialFilters;
    return { ...initialFilters, ...raw, tipoUsuario: normalizeTipoUsuario(raw) };
  });
  // Filtros aplicados (solo se actualizan al hacer clic en Buscar; mantienen la petición estable)
  const [appliedFilterOptions, setAppliedFilterOptions] = useState(() => {
    const savedFilters = localStorage.getItem("usersPageFilters");
    const raw = savedFilters ? JSON.parse(savedFilters) : initialFilters;
    return { ...initialFilters, ...raw, tipoUsuario: normalizeTipoUsuario(raw) };
  });
  // Estado para el campo de búsqueda
  const [searchText, setSearchText] = useState(() => {
    const saved = localStorage.getItem("usersPage_searchText");
    return saved || "";
  });
  const [appliedSearchText, setAppliedSearchText] = useState(() => {
    const saved = localStorage.getItem("usersPage_searchText");
    return saved || "";
  });
  const [sortBy, setSortBy] = useState(() => {
    const saved = localStorage.getItem("usersPage_sortBy");
    return saved || "createdAt";
  });
  const [sortOrder, setSortOrder] = useState(() => {
    const saved = localStorage.getItem("usersPage_sortOrder");
    return saved === "asc" ? "asc" : "desc";
  });
  const [pageSize, setPageSize] = useState(() => {
    const saved = localStorage.getItem("usersPage_pageSize");
    const n = saved ? parseInt(saved, 10) : 100;
    return PAGE_SIZE_OPTIONS.includes(n) ? n : 100;
  });
  const history = useHistory();

  // Handler para actualizar la búsqueda (se usa tanto desde el TextField como desde el Table)
  const handleTableSearchChange = React.useCallback((value) => {
    const trimmedValue = value ? value : "";
    setSearchText(trimmedValue);
    if (trimmedValue) {
      localStorage.setItem("usersPage_searchText", trimmedValue);
    } else {
      localStorage.removeItem("usersPage_searchText");
    }
  }, []);
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  function buttonFormatter(cell) {
    // Buscar en los datos transformados que se muestran en la tabla
    const transformedData = getData(data, userTypes);
    const elem = transformedData.find((item) => item.id === cell);
    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              // Guardar filtros actuales antes de navegar
              localStorage.setItem(
                "usersPageFilters",
                JSON.stringify(filterOptions),
              );
              history.push("/edit-user/" + cell);
            }}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {(canEditUsersModule(user?.role) && !isReadOnlyConsultor(user?.role)) && (
          <>
            <Tooltip title={elem?.active ? "Disable" : "Enable"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setUserId(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setUserId(cell);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  const columns = [
    { dataField: "name", text: "Nombre", sort: true },
    { dataField: "apellido1", text: "Apellido 1", sort: true },
    { dataField: "apellido2", text: "Apellido 2", sort: true },
    { dataField: "dni", text: "DNI", sort: true },
    { dataField: "email", text: "Email", sort: true },
    { dataField: "type", text: "Tipo Usuario", sort: true },
    {
      dataField: "createdAt",
      text: "Fecha alta",
      sort: true,
      formatter: dateFormatter,
    },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    getUserTypes().then((res) => {
      setUserTypes(res.data);
    });
    getProvincias().then((res) => {
      if (res.status === 200) {
        setProvincias(res.data);
      }
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    const params = {
      page: currentPage,
      limit: pageSize,
      role: "user",
      getDisabled: "true",
    };
    if (appliedFilterOptions.active) params.active = true;
    if (appliedFilterOptions.tipoUsuario?.length)
      params.tipoUsuario = appliedFilterOptions.tipoUsuario;
    if (appliedFilterOptions.provincia)
      params.provincia = appliedFilterOptions.provincia;
    if (appliedFilterOptions.fechaAltaDesde)
      params.fechaAltaDesde = appliedFilterOptions.fechaAltaDesde;
    if (appliedFilterOptions.fechaAltaHasta)
      params.fechaAltaHasta = appliedFilterOptions.fechaAltaHasta;
    if (appliedFilterOptions.numeroSocio)
      params.numeroSocio = appliedFilterOptions.numeroSocio;
    if (appliedSearchText) params.search = appliedSearchText;
    const backendSortBy = SORT_FIELD_TO_BACKEND[sortBy] || "createdAt";
    params.sortBy = backendSortBy;
    params.sortOrder = sortOrder;

    getUsersPaginated(params)
      .then((res) => {
        if (res.status === 200) {
          const responseData = res.data.data || res.data;
          const pagination = res.data.pagination;
          setData(Array.isArray(responseData) ? responseData : []);
          setUsers(Array.isArray(responseData) ? responseData : []);
          if (pagination) {
            setTotalPages(pagination.pages || 1);
            setTotalUsers(pagination.total || 0);
          } else {
            setTotalPages(1);
            setTotalUsers(responseData?.length || 0);
          }
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get users.",
        });
      })
      .finally(() => setLoading(false));
  }, [
    refresh,
    currentPage,
    appliedFilterOptions,
    appliedSearchText,
    sortBy,
    sortOrder,
    pageSize,
  ]);

  const handleSearch = () => {
    setAppliedFilterOptions({ ...filterOptions });
    setAppliedSearchText(searchText);
    setCurrentPage(1);
    localStorage.setItem("usersPageFilters", JSON.stringify(filterOptions));
    localStorage.setItem("usersPage_currentPage", "1");
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setAppliedFilterOptions(initialFilters);
    setSearchText("");
    setAppliedSearchText("");
    setCurrentPage(1);
    localStorage.removeItem("usersPageFilters");
    localStorage.removeItem("usersPage_searchText");
    localStorage.setItem("usersPage_currentPage", "1");
    setRefresh(true);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    localStorage.setItem("usersPage_currentPage", newPage.toString());
  };

  const handleSortChange = (sortField, order) => {
    // Evitar reset de página cuando la tabla re-dispara el mismo sort al actualizar datos
    // (react-bootstrap-table2 puede llamar onTableChange("sort") al re-renderizar con nuevos data)
    const nextSortBy = sortField || "createdAt";
    const nextSortOrder = order || "desc";
    if (nextSortBy === sortBy && nextSortOrder === sortOrder) return;

    setSortBy(nextSortBy);
    setSortOrder(nextSortOrder);
    setCurrentPage(1);
    localStorage.setItem("usersPage_sortBy", nextSortBy);
    localStorage.setItem("usersPage_sortOrder", nextSortOrder);
    localStorage.setItem("usersPage_currentPage", "1");
  };

  const handlePageSizeChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (!PAGE_SIZE_OPTIONS.includes(value)) return;
    setPageSize(value);
    setCurrentPage(1);
    localStorage.setItem("usersPage_pageSize", value.toString());
    localStorage.setItem("usersPage_currentPage", "1");
  };

  const renderFiltersContent = () => {
    return (
      <div style={{ padding: "5px 0 0 0" }}>
        {/* Primera fila: Filtros en grid organizado - alineados por abajo */}
        <div className="row align-items-end">
          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="search"
              label="Buscar"
              placeholder="Buscar en todos los campos..."
              value={searchText}
              onChange={(e) => {
                // Llamar directamente al handler para actualizar el ToolkitProvider
                handleTableSearchChange(e.target.value);
              }}
              margin="dense"
              variant="outlined"
              fullWidth
              style={{ marginTop: 0, marginBottom: 0 }}
            />
          </div>

          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="numeroSocio"
              label="Número de Socio"
              type="number"
              value={filterOptions.numeroSocio || ""}
              onChange={(e) =>
                setFilterOptions({
                  ...filterOptions,
                  numeroSocio: e.target.value,
                })
              }
              margin="dense"
              variant="outlined"
              fullWidth
              style={{ marginTop: 0, marginBottom: 0 }}
            />
          </div>

          <div className="col-md-3 col-sm-6 mb-3">
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: 500,
                fontSize: "14px",
                color: "#333",
              }}
            >
              Tipo de Usuario
            </label>
            <Select
              isMulti
              value={userTypes.filter((t) =>
                (filterOptions.tipoUsuario || []).includes(String(t._id))
              )}
              onChange={(selected) =>
                setFilterOptions({
                  ...filterOptions,
                  tipoUsuario: selected ? selected.map((s) => String(s._id)) : [],
                })
              }
              options={userTypes}
              getOptionLabel={(option) => option.titulo}
              getOptionValue={(option) => option._id}
              placeholder="Todos los tipos"
              isClearable
              styles={{
                control: (provided) => ({
                  ...provided,
                  minHeight: "40px", // Misma altura que TextField con margin="dense"
                  borderColor: "#ced4da",
                }),
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
            />
          </div>

          <div className="col-md-3 col-sm-6 mb-3">
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: 500,
                fontSize: "14px",
                color: "#333",
              }}
            >
              Provincia
            </label>
            <Select
              value={
                filterOptions.provincia
                  ? provincias.find(
                      (p) => p.fullName === filterOptions.provincia,
                    )
                  : null
              }
              onChange={(selected) =>
                setFilterOptions({
                  ...filterOptions,
                  provincia: selected ? selected.fullName : null,
                })
              }
              options={provincias}
              getOptionLabel={(option) => option.fullName}
              getOptionValue={(option) => option.fullName}
              placeholder="Todas las provincias"
              isClearable
              styles={{
                control: (provided) => ({
                  ...provided,
                  minHeight: "40px", // Misma altura que TextField con margin="dense"
                  borderColor: "#ced4da",
                }),
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
            />
          </div>

          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="fechaAltaDesde"
              label="Fecha Alta Desde"
              type="date"
              value={filterOptions.fechaAltaDesde || ""}
              onChange={(e) =>
                setFilterOptions({
                  ...filterOptions,
                  fechaAltaDesde: e.target.value,
                })
              }
              InputLabelProps={{ shrink: true }}
              margin="dense"
              variant="outlined"
              fullWidth
              style={{ marginTop: 0, marginBottom: 0 }}
            />
          </div>

          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="fechaAltaHasta"
              label="Fecha Alta Hasta"
              type="date"
              value={filterOptions.fechaAltaHasta || ""}
              onChange={(e) =>
                setFilterOptions({
                  ...filterOptions,
                  fechaAltaHasta: e.target.value,
                })
              }
              InputLabelProps={{ shrink: true }}
              margin="dense"
              variant="outlined"
              fullWidth
              style={{ marginTop: 0, marginBottom: 0 }}
            />
          </div>
        </div>

        {/* Switches y botones de acción en la misma línea */}
        <div className="row">
          <div className="col-12">
            <div
              className="d-flex justify-content-between align-items-center flex-wrap"
              style={{ marginTop: "10px", marginBottom: "10px", gap: "15px" }}
            >
              {/* Switches a la izquierda */}
              <div
                className="d-flex align-items-center flex-wrap"
                style={{ gap: "30px" }}
              >
                <FormControlLabel
                  control={
                    <Switch
                      checked={filterOptions.active}
                      onChange={() =>
                        setFilterOptions({
                          ...filterOptions,
                          active: !filterOptions.active,
                        })
                      }
                      name="checkActive"
                      style={{ color: "#f3691a" }}
                    />
                  }
                  label={
                    filterOptions.active
                      ? "Solo activos"
                      : "Todos (activos/inactivos)"
                  }
                  style={{ margin: 0 }}
                />
              </div>
              {/* Botones a la derecha */}
              <div className="d-flex">
                <Button
                  variant="contained"
                  onClick={handleSearch}
                  startIcon={<SearchIcon />}
                  style={{
                    minWidth: "120px",
                    backgroundColor: "#f3691a",
                    color: "#fff",
                    marginRight: "10px",
                  }}
                >
                  Buscar
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleClearFilters}
                  startIcon={<FilterOffIcon />}
                  style={{
                    minWidth: "120px",
                    borderColor: "#f3691a",
                    color: "#f3691a",
                  }}
                >
                  Limpiar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Card>
        <CardHeader title="Usuarios list">
          <CardHeaderToolbar>
            {canEditUsersModule(user?.role) && !isReadOnlyConsultor(user?.role) && (
            <Button
              variant="contained"
              onClick={() => history.push("/edit-user")}
              startIcon={<AddIcon />}
              style={{
                backgroundColor: "#f3691a",
                color: "#fff",
              }}
            >
              Añadir nuevo
            </Button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody style={{ paddingTop: "15px" }}>
          {/* Filtros siempre visibles con mejor diseño */}
          <Card style={{ marginBottom: "15px", backgroundColor: "#f8f9fa" }}>
            <CardBody style={{ padding: "15px 20px" }}>
              {renderFiltersContent()}
            </CardBody>
          </Card>

          {loading && (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <Typography>Cargando usuarios...</Typography>
            </div>
          )}
          {!loading && (
            <>
              <Table
                data={getData(data, userTypes)}
                columns={columns}
                pageKey="usersPage"
                searchText={searchText}
                onSearchChange={handleTableSearchChange}
                noPagination
                remoteSort
                sort={{ dataField: sortBy, order: sortOrder }}
                onSortChange={handleSortChange}
              />
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "12px",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  style={{ minWidth: 140 }}
                >
                  <InputLabel>Filas por página</InputLabel>
                  <MuiSelect
                    value={pageSize}
                    onChange={handlePageSizeChange}
                    label="Filas por página"
                  >
                    {PAGE_SIZE_OPTIONS.map((size) => (
                      <MenuItem key={size} value={size}>
                        {size}
                      </MenuItem>
                    ))}
                  </MuiSelect>
                </FormControl>
                <Button
                  type="button"
                  variant="outlined"
                  onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
                  disabled={currentPage === 1}
                  style={{ borderColor: "#f3691a", color: "#f3691a" }}
                >
                  Anterior
                </Button>
                <Typography style={{ minWidth: "180px", textAlign: "center" }}>
                  Página {currentPage} de {totalPages} ({totalUsers} usuarios)
                </Typography>
                <Button
                  type="button"
                  variant="outlined"
                  onClick={() =>
                    handlePageChange(Math.min(totalPages, currentPage + 1))
                  }
                  disabled={currentPage === totalPages}
                  style={{ borderColor: "#f3691a", color: "#f3691a" }}
                >
                  Siguiente
                </Button>
              </div>
            </>
          )}

          <ConfirmDialog
            title={`Are you sure you want to ${
              userId?.active ? "disable" : "enable"
            } this user?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              if (!userId || !userId.id) {
                alertError({
                  error: new Error("User ID not found"),
                  customMessage: "Could not find user ID. Please try again.",
                });
                setOpenConfirmDialog(null);
                return;
              }
              changeStatusUser(userId.id, !userId?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${userId?.active ? "Disabled!" : "Enabled!"}`,
                      customMessage: `User ${
                        userId?.active ? "disabled" : "enabled"
                      } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${
                      userId?.active ? "disable" : "enable"
                    } user.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"Are you sure you want to remove this user?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteUser(userId)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "User removed successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove user.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
